import { AnyObject } from 'types';
import { Editor } from 'slate';
import { generateSequentialUUID } from 'utils/js';

export type CreateAnnotation = (customData: AnyObject, options?: any) => void;

export default function createAnnotation(editor): CreateAnnotation {
  return function (customData: AnyObject): any {
    customData['annotationId'] = generateSequentialUUID();

    Object.entries(customData).forEach(([key, value]) => {
      Editor.addMark(editor, key, value);
    });

    return customData;
  };
}
